// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"310":"759a0b21732741372509","926":"3b2ffea26e1251e3e8ae","956":"7c7bac2121b54fc9391b"}[chunkId] + ".chunk.js";
};